import apiConfig from 'constants/apiConfig';
import { CreatorTag } from 'types/creators';
import axiosClient from 'utils/axiosClient';

const withAgencyId = (url: string, agencyId: string) => url.replace('<agencyId>', agencyId);

export const fetchCreatorTags = async (agencyId: string): Promise<CreatorTag[]> => {
    const response = await axiosClient.get(withAgencyId(apiConfig.FETCH_CREATOR_TAGS.url, agencyId));
    return response.data.items;
};

export const searchCreatorTags = async (agencyId: string, q: string): Promise<string[]> => {
    const response = await axiosClient.get(withAgencyId(apiConfig.SEARCH_CREATOR_TAGS.url, agencyId), {
        params: { q },
    });
    return response.data.results;
};

export const createCreatorTag = async (agencyId: string, name: string): Promise<CreatorTag> => {
    const response = await axiosClient.post(withAgencyId(apiConfig.CREATE_CREATOR_TAG.url, agencyId), {
        name,
    });
    return response.data;
};

export const updateCreatorTag = async (
    agencyId: string,
    creatorTagId: number,
    name: string
): Promise<CreatorTag> => {
    const response = await axiosClient.put(
        withAgencyId(apiConfig.UPDATE_CREATOR_TAG.url, agencyId).replace(
            '<creatorTagId>',
            String(creatorTagId)
        ),
        { name }
    );
    return response.data;
};

export const deleteCreatorTag = async (agencyId: string, creatorTagId: number): Promise<void> => {
    await axiosClient.delete(
        withAgencyId(apiConfig.DELETE_CREATOR_TAG.url, agencyId).replace(
            '<creatorTagId>',
            String(creatorTagId)
        )
    );
};
